import dashboardSettingsStore from '../../../stores/dashboard-settings-store';
import { PROFILE_CAPABILITIES } from '../../../models/ProfileCapabilities';
import { RESOLUTION_ID } from '../constants';

export type ResolutionDisplayFieldVisibility = {
    showDisplayName: boolean;
    showDisplayDescription: boolean;
};


export const getResolutionDisplayFieldVisibility = (
    resolutionId: RESOLUTION_ID
): ResolutionDisplayFieldVisibility => {
    const portalTranslations = dashboardSettingsStore.resolveCapability(
        PROFILE_CAPABILITIES.PORTAL_TRANSLATIONS
    );
    const manualExchangeCapability = dashboardSettingsStore.resolveCapability(
        PROFILE_CAPABILITIES.MANUAL_EXCHANGE
    );
    const productExchangeCapability = dashboardSettingsStore.resolveCapability(
        PROFILE_CAPABILITIES.PRODUCT_EXCHANGE
    );

    switch (resolutionId) {
        case RESOLUTION_ID.MANUAL_EXCHANGE:
            return {
                showDisplayName: manualExchangeCapability?.isDisplayNameSupported !== false,
                showDisplayDescription: manualExchangeCapability?.isDisplayDescriptionSupported !== false,
            };

        case RESOLUTION_ID.PRODUCT_EXCHANGE:
            return {
                showDisplayName: productExchangeCapability?.isDisplayNameSupported !== false,
                showDisplayDescription: productExchangeCapability?.isDisplayDescriptionSupported !== false,
            };

        case RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE:
            return {
                showDisplayName: true,
                showDisplayDescription: true,
            };

        default:
            return {
                showDisplayName: portalTranslations?.isRefundMethodsScopeSupported !== true,
                showDisplayDescription: portalTranslations?.isRefundMethodsScopeSupported !== true,
            };
    }
};
